module.exports = __webpack_public_path__ + "img/text.7b172c1f.png";